import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const InsKurusuraSubmarineLawn = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/image3.jpeg",
  //   "/images/image9.jpeg",
  //   "/images/image10.jpeg",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions (General Public)",
      rent: 20000,
      deposit: 10000,
      gst: 3960,
      cleaning: 2000,
      total: 35960,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img
                  src={item.url}
                  alt={`INS Kurusura Submarine Lawn Image ${idx + 1}`}
                />
                <div className="overlay">
                  <h1>INS Kurusura Submarine Lawn</h1>
                  <p>Venue for Various Public and Private Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>INS Kurusura Submarine Lawn</strong> is a premium outdoor
            venue situated in the beautiful city of Visakhapatnam. It's perfect
            for various events like birthday functions, corporate meetings, and
            social gatherings. The lawn offers ample space and is equipped with
            modern amenities to ensure your event is successful.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Spacious Outdoor Lawn</li>
            <li>✅ Ideal for Official and Social Gatherings</li>
            <li>✅ Well-Maintained Grounds</li>
            <li>✅ Ample Parking Space</li>
          </ul>
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Additional charges for electricity and
            cleaning may apply.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: INS Kurusura Submarine Lawn,
              Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@inskurusuralawn.com
            </p>
          </div>

          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InsKurusuraSubmarineLawn;
